import React from 'react'
import fusion from "../assets/fusionlogo.png"
import python from "../assets/python.png"
import matlab from "../assets/matlab.png"
import solidworks from "../assets/solidworks.png"
import cplus from "../assets/c++.png"
import ros from "../assets/ros.png"
// import autocad from "../assets/autocad.png"
import gazibo from "../assets/gazebo.png"
import tensorflow from "../assets/tensorflow.png"
import control from "../assets/controlsystem.png"
import robot from "../assets/robot.png"
// import ubantu from "../assets/ubuntu.png"
import ml from "../assets/icomachine-learning.png"
import vision from "../assets/vision.png"
import rein from "../assets/rein.png"
import pytorch from "../assets/pytorch.png"
import deep from "../assets/deep.png"
import opencv from "../assets/opencv.png"
import nltk from "../assets/nltk.png"
import spacy from "../assets/spaCy.png"
const Experience = () => {

    const techs=[
        {
            id:5,
            src:cplus,
            title:'C++',
            style:'shadow-purple-600'
        },
        {
            id:4,
            src:python,
            title:'PYTHON',
            style:'shadow-blue-500'
        },
        {
            id:7,
            src:tensorflow,
            title:'TensorFlow',
            style:'shadow-yellow-500'
        },
        {
            id:8,
            src:pytorch,
            title:'PyTorch',
            style:'shadow-red-500'
        },
        {
            id:10,
            src:ml,
            title:'Machine Learning',
            style:'shadow-pink-500'
        },
        {
            id:11,
            src:deep,
            title:'Deep Learning',
            style:'shadow-green-500'
        },
        {
            id:2,
            src:rein,
            title:'Reinforcement Learning',
            style:'shadow-purple-400'
        },
        {
            id:15,
            src:opencv,
            title:'OPEN CV',
            style:'shadow-blue-700'
        },
        {
            id:0,
            src:vision,
            title:'COMPUTER VISION',
            style:'shadow-gray-500'
        },
        {
            id:16,
            src:spacy,
            title:'SpaCy',
            style:'shadow-blue-300'
        },
        {
            id:15,
            src:nltk,
            title:'Natural Language Processing ',
            style:'shadow-gray-800'
        },
        {
            id:9,
            src:matlab,
            title:'MATLAB',
            style:'shadow-blue-300'
        },
        {
            id:13,
            src:solidworks,
            title:'SolidWorks',
            style:'shadow-red-600'
        },
        {
            id:12,
            src:gazibo,
            title:'GAZEBO',
            style:'shadow-white'
        },
        {
            id:14,
            src:fusion,
            title:'FUSION 360',
            style:'shadow-orange-500'
        },
        {
            id:6,
            src:ros,
            title:'',
            style:'shadow-green-800'
        },
        {
            id:1,
            src:control,
            title:'CONTROLS',
            style:'shadow-green-400'
        },
        {
            id:3,
            src:robot,
            title:'Sensor Fusion & Motion Planning ',
            style:'shadow-purple-400'
        },

    ]

  return (
    <div name='skills' className="w-full h-auto  bg-gradient-to-b  from-gray-800 to-black">
        <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
            <div>
                <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline ">Skills</p>
                <p className="py-6">These are the technologies I've worked with</p>
            </div>

            <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">

                {
                    techs.map(({id,src,title,style})=>(
                        <div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg h-30 ${style}`}>
                    <img src={src} alt="" className="w-20 mx-auto"/>
                    <p className="mt-0">{title}</p>
                </div>
                    ))
                }

            </div>
        </div>

    </div>
  )
}

export default Experience